import { AssetCategoryWithElementsType } from './types';

// Business Formal
const WARDROBE_BUSINESS_FORMAL = [
  'Cocktail Dress',
  'Ball Gown',
  'Business Suit',
  'Dinner Jacket/Tuxedo',
  'Pinstripe Suit',
  'Three Piece Black Suit',
  'Top Hat and Tails',
];

const WARDROBE_BUSINESS_FORMAL_CATEGORY = {
  label: 'Business / Formal',
  list: WARDROBE_BUSINESS_FORMAL,
};

// Emergency Services & Military
const WARDROBE_EMERGENCY_SERVICES_MILITARY = [
  'Police Uniform (Blue)',
  'Police Uniform (Black)',
  'Riot Gear',
  'U.S. Army',
  'U.S. Navy',
  'U.S. Air Force',
  'U.S. Coast Guard',
  'U.S. Marine Corps',
  'Lab Coat',
  'Medical Scrubs',
  'Paramedic (Full uniform)',
  'FireFighter (Full gear)',
];

const WARDROBE_EMERGENCY_SERVICES_MILITARY_CATEGORY = {
  label: 'Emergency Services & Military',
  list: WARDROBE_EMERGENCY_SERVICES_MILITARY,
};

// Other Work Attire
const WARDROBE_OTHER_WORK_ATTIRE = [
  'Bus Driver',
  'Cabin Crew',
  'Chauffeur',
  'Judge Robes',
  'Pilot',
  'Boat Captain',
  'Flight Attendant',
  'Sailor',
  'Railway',
  'Traffic Warden',
  'Postman',
  'Prison Warden',
  'Security Guard',
  'Construction',
  'Farmer / Rancher',
  'Bee Keeper',
  'Sports Referee',
  'Chef Whites',
  'Butler',
  'Maid',
  'Janitor',
];

const WARDROBE_OTHER_WORK_ATTIRE_CATEGORY = {
  label: 'Other Work Attire',
  list: WARDROBE_OTHER_WORK_ATTIRE,
};

// Sports
const WARDROBE_SPORTS = [
  'Football',
  'Soccer',
  'Baseball / Softball',
  'Basketball',
  'Wrestling Singlet',
  'Track & Field',
  'Cheerleader',
  'Tennis',
  'Ballet',
  'Combat Sports / MMA',
  'Marital Arts Gi',
  'Golfer',
  'Hockey',
  'Cycling Lycra Gear',
  'Equestrian',
  'Fencing',
  'Archery',
  'Skiier / Snowboarder',
  'Figure Skating',
  'Wet Suit',
  'Swimmer',
];

const WARDROBE_SPORTS_CATEGORY = {
  label: 'Sports',
  list: WARDROBE_SPORTS,
};

// Styles / Costumes
const WARDROBE_STYLES_COSTUMES = [
  'Biker (with Leathers)',
  'Unhoused / Homeless',
  'Inmate / Prisoner',
  'Burlesque',
  'Exotic Dancer',
  'Flamenco',
  'Belly Dancer',
  'Vegas Showgirl',
  'Carnival',
  'Circus',
  'Clown',
  'Drag',
  'Emo',
  'Santa / Holiday Characters',
  'Farmer',
  'Fisherman',
  'Glam Rock',
  'Goth',
  'Hippy',
  'Punk',
  'Raver',
  'Metal / Classic Rock',
  'Skin Head',
  'Hiker (Hiking Boots)',
  'Yoga / Gymwear',
  'Swimwear',
  'Pirate',
];

const WARDROBE_STYLES_COSTUMES_CATEGORY = {
  label: 'Styles / Costumes',
  list: WARDROBE_STYLES_COSTUMES,
};

// Time Period
const WARDROBE_TIME_PERIOD = [
  '1920s',
  '1930s',
  '1940s',
  '1950s',
  '1960s',
  '1970s',
  '1980s',
  '1990s',
  '2000s',
  'Steampunk',
  'Renaissance',
  'Western',
  'Victoria',
  'Cyberpunk',
];

const WARDROBE_TIME_PERIOD_CATEGORY = {
  label: 'Time Period',
  list: WARDROBE_TIME_PERIOD,
};

// Religious Attire
const WARDROBE_RELIGIOUS_ATTIRE = [
  'Buddhist Monk Robes',
  'Christian Bishop',
  'Christian Choir Attire',
  'Christian Monk',
  'Christian Nun',
  'Christian Priest',
  'Christian Vicar',
  'Hindu Kurta',
  'Hindu Sari',
  'Jewish Hasidic Attire',
  'Jewish Yarmulke',
  'Jewish Tallit',
  'Muslim Abaya',
  'Muslim Burka',
  'Muslim Hijab',
  'Muslim Jilbab',
  'Muslim Keffiyeh',
  'Muslim Niqab',
  'Muslim Taqiyah',
  'Muslim Thawb',
  'Sikh Turban',
  'Sikh Shalwar Kameez',
  'Sikh Kurta Pajama',
];

const WARDROBE_RELIGIOUS_ATTIRE_CATEGORY = {
  label: 'Religious Attire',
  list: WARDROBE_RELIGIOUS_ATTIRE,
};

// National Dress
const WARDROBE_NATIONAL_TRADITIONAL_DRESS = [
  'Chinese Cheongsam',
  'Japanese Kimono',
  'Korean Hanbok',
  'Indian Sari',
  'Indian Sherwani',
  'Indian Kurta',
  'Indonesian/Malay Kebaya',
  'Vietnamese Áo Dài',
  'Filipino Barong Tagalog',
  'Spanish Flamenco Dress',
  'Greek Fustanella',
  'German/Austrian Dirndl',
  'Scottish Kilt',
  'Middle Eastern Thawb',
  'Middle Eastern Keffiyeh',
  'Middle Eastern Abaya',
  'Middle Eastern Fez',
  'African Traditional Attire',
  'Native American Regalia',
  'Mexican Traditional Attire',
  'South American Traditional Attire',
  'Russian Traditional Dress',
];

const WARDROBE_NATIONAL_TRADITIONAL_DRESS_CATEGORY = {
  label: 'National Dress',
  list: WARDROBE_NATIONAL_TRADITIONAL_DRESS,
};

const WARDROBE_CATEGORIES = [
  WARDROBE_BUSINESS_FORMAL_CATEGORY,
  WARDROBE_EMERGENCY_SERVICES_MILITARY_CATEGORY,
  WARDROBE_OTHER_WORK_ATTIRE_CATEGORY,
  WARDROBE_SPORTS_CATEGORY,
  WARDROBE_STYLES_COSTUMES_CATEGORY,
  WARDROBE_TIME_PERIOD_CATEGORY,
  WARDROBE_RELIGIOUS_ATTIRE_CATEGORY,
  WARDROBE_NATIONAL_TRADITIONAL_DRESS_CATEGORY,
];

export const WARDROBE_CATEGORIES_DETAILED: AssetCategoryWithElementsType[] =
  WARDROBE_CATEGORIES.map(({ label, list }) => ({
    label,
    list,
  }));
